class GoogleMapGeocenterController {
    constructor($q, geolocation) {
        this.$q = $q;
        this.geolocation = geolocation;
    }

    getLocation() {
        return this.$q((resolve, reject) => {
            if (this.geolocation) {
                this.geolocation.getCurrentPosition(resolve, reject);
            } else {
                reject();
            }
        });
    }

    setMap(map) {
        this.map = map;

        this.getLocation()
            .then(position => this.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude)));
    }

    setCenter(latlng) {
        this.map.setCenter(latlng);

        if (this.onCenter) {
            this.onCenter({ latlng });
        }
    }
}

const googleMapGeocenterDirectiveDefinition = () => ({
    restrict: 'E',
    require: ['olyGoogleMapGeocenter', '^olyGoogleMap'],
    scope: {},
    bindToController: {
        onCenter: '&?',
    },
    controller: ['$q', 'geolocation', GoogleMapGeocenterController],
    controllerAs: 'googleMapGeocenterCtrl',
    link(scope, element, attrs, controllers) {
        const geocenterCtrl = controllers[0];
        const mapCtrl = controllers[1];

        geocenterCtrl.setMap(mapCtrl.getMap());
    },
});

module.exports = {
    GoogleMapGeocenterController,
    googleMapGeocenterDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-map-geocenter.directive.js